export default class Validator {
    constructor() {
        this.errors = {};
    }

    validate(values, rules) {
        this.errors = {}

        Object.keys(rules).forEach(key => {
            let ruleItems = rules[key]
            let value = values[key]
            
            ruleItems.forEach(ruleItem => {
                let strSplit = ruleItem.split(':')

                let rule = strSplit[0]

                if (rule === 'required') {
                    this.required(key, value)
                    return
                }

                if (rule === 'max') {
                    this.maxChars(key, value, strSplit[1])
                    return
                }
            })
        });   

        return this.errors
    }

    ///////

    required(key, value) {
        if (value) 
            return

        this.errors[key] = ['The field is required']
    }

    maxChars(key, value, charLimit) {
        if (value.length <= charLimit) 
            return

        this.errors[key] = ['Maximum number of characters is ' + charLimit]
    }
}